module.exports = __webpack_public_path__ + "img/sample-avatar.c81861ea.jpg";